<script lang="ts">
  import { createEventDispatcher, onMount } from "svelte";
  import { CustomListService } from "../../../../services/custom-list.service";
  import type { IDropdownItem } from "../../../../services/DTO/dropdown-item";
  import SearchDropdown from "./SearchDropdown.svelte";

  export let placeholder: string = "";
  export let required: boolean = false;
  export let clearVisible: boolean = false;
  export let filterVisible: boolean = true;
  export let name: string = "";
  export let schemaId: number = 0;
  export let value: number = null;

  const dispatch = createEventDispatcher();

  let items: IDropdownItem[] = [];

  function onFilter(event: CustomEvent) {
    let filter: string = event.detail;
    search(filter);
  }

  async function search(filter: string) {
    let selfId = !!value ? value : 0;
    let values = await CustomListService.searchCustomListValueCombo(
      schemaId,
      selfId,
      filter
    ).toPromise();
    items = values.payload || [];
  }

  function onSelect(event: CustomEvent) {
    if (event == null) {
      dispatch("clear");
    } else {
      dispatch("select", event.detail);
    }
  }

  onMount(() => search(""));
</script>

<SearchDropdown
  {placeholder}
  {required}
  {clearVisible}
  {filterVisible}
  {name}
  {items}
  bind:value
  on:filter={onFilter}
  on:select={onSelect}
/>
